module.exports = __webpack_public_path__ + "fonts/63f573c4f806c10fa904fe911089f058.woff";